import {
  CHANGE_ACTIVE_ITEM_LIVELIST, CHANGE_ACTIVE_ITEM_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_LOG, SOLVE_PROBLEM,
  CHANGE_ACTIVE_ITEM_CONFIG, CHANGE_ACTIVE_ITEM_TRAFFIC,
  CHANGE_ACTIVE_ITEM_INVENTORY, CHANGE_ACTIVE_TS_EXPERT
  
} from "../actions/types";

// ---- Actions ----
export function tsExpertAction() {
  return {
    type: CHANGE_ACTIVE_TS_EXPERT,
    payload: { activeItem: "/" }
  };
}

export function livelistAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST,
    payload: { activeItem: "/livelist" }
  };
}

export function inventoryAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_INVENTORY,
    payload: { activeItem: "/inventory" }
  };
}

export function topologyAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_TOPOLOGY,
    payload: { activeItem: "/topology" }
  };
}

export function trafficAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_TRAFFIC,
    payload: { activeItem: "/traffic" }
  };
}

export function logAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LOG,
    payload: { activeItem: "/log" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: { 
      solve: solve,
      problem: problem 
    }
  };
}